import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
  #hqv-amenities-section{
    .test-code{
      content: '';
      display: block;
      height: 154px;
      margin-top: -154px;
      visibility: hidden;
    }
  }
  .amenities-component{
    scroll-margin-top: ${toRem(128)};
    margin: auto;
    max-width: ${toRem(1440)};
    background-color: ${theme.color['white']};
    font-family: ${theme.fonts['fontFamilySwiss']};
    .component-heading{
      margin-bottom: ${toRem(24)};
    }
    .remove-border {
      border-bottom: 0px !important;
    }
    .amenities-content{
      padding-bottom: ${toRem(37)};
      border-bottom: ${toRem(1)} solid ${theme.color['alto']};
      .component-content{
        display: flex;
        flex-wrap: wrap;
        .amenity-list-item{
          display: flex;
          flex-direction: row;
          flex:0 0 33.33%;
          align-items: flex-start !important;
          padding: 0;
          .icon-holder{
            &::before{
              margin-right: ${toRem(17)};
              position: relative;
            }
          }
          .amenity-name{
            margin-bottom: ${toRem(24)};
            padding-right: ${toRem(10)};
          }
        }
      }
      .see-amenities-button{
        display: flex;
        cursor: pointer;
        padding-top: ${toRem(7)};
        margin-bottom: ${toRem(40)};
        .label-text{
          margin-right: ${toRem(18)};
        }
        .label-icon{
          margin-left: ${toRem(-5)};
          &::before{
            position: relative;
            top: ${toRem(-4)};
          }
        }
      }
      .hide-content{
        display: none;
      }
    }
  }
  .space-buffer{
    scroll-margin-top: ${toRem(245)};
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .amenities-component{
      margin-top: ${toRem(-150)};
      padding-top: ${toRem(150)};
    }
    .space-buffer{
      margin-top: ${toRem(-275)};
      padding-top: ${toRem(275)};
    }
  }

  @media only ${theme.mediaQuery.smallerTablet} {
    .amenities-component{
      scroll-margin-top: ${toRem(30)};
      padding-top: ${toRem(33)};
      .component-heading{
        margin-bottom: ${toRem(24)};
      }
      .amenities-content{
        padding-bottom: ${toRem(31)};
        .see-amenities-button{
          .label-text{
          }
        }
      }
    }
  }
  @media only ${theme.mediaQuery.allMobiles} {
    .amenities-component{
      scroll-margin-top: ${toRem(30)};
      padding: ${toRem(20)} 0 0;
      .component-heading{
        margin-bottom: ${toRem(25)};
      }
      .amenities-content{
        padding-bottom: ${toRem(21)};
        .component-content{
          flex-direction: column;
          .amenity-list-item{
            width: 100%;
          }
        }
      }
    }
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .icon-decorative::before{
      color: ${theme.color['light-orange-2']};
    }
  }
  .hqv-modal {
    &.amenities-component{
      scroll-margin-top: ${toRem(30)};
      padding-top: ${toRem(33)};
      @media only ${theme.mediaQuery.allMobiles} {
        padding: 0;
        margin-left: ${toRem(16)};
        margin-right: ${toRem(16)};
      }
      .component-heading{
        margin-bottom: ${toRem(24)};
      }
      .amenities-content{
        padding-bottom: ${toRem(31)};
        @media only ${theme.mediaQuery.allMobiles} {
          padding-bottom: ${toRem(64)};
        }
        .see-amenities-button{
          .label-text{
          }
        }
      }
    }
  }`}
`;
